"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var url_1 = __importDefault(require("./url"));
exports.Url = new url_1.default();
var url_2 = require("./url");
exports.ALL_FOLDER_ID = url_2.ALL_FOLDER_ID;
exports.SCRAPS_FOLDER_ID = url_2.SCRAPS_FOLDER_ID;
exports.ALL_FOLDER_NAME = url_2.ALL_FOLDER_NAME;
exports.SCRAPS_FOLDER_NAME = url_2.SCRAPS_FOLDER_NAME;
var constants_1 = require("./constants");
exports.URLS = constants_1.URLS;
exports.PROJECTS = constants_1.PROJECTS;
exports.USER_PROFILE_SECTION_PATHS = constants_1.USER_PROFILE_SECTION_PATHS;
exports.USER_PROFILE_POSTS_SUB_PATHS = constants_1.USER_PROFILE_POSTS_SUB_PATHS;
exports.USER_PROFILE_SHOP_SUB_PATHS = constants_1.USER_PROFILE_SHOP_SUB_PATHS;
exports.CHECKOUT_IDS = constants_1.CHECKOUT_IDS;
//# sourceMappingURL=index.js.map